import React from 'react';
import { SlideOver } from '../../tailwindComponents/slideOver/SlideOver';
import { useGetSelfAdminUserQuery } from '../../API/administration/AdminUsersAPI';
import { AdminTitle } from '../shared/AdminTitle';
import { EditSelfForm } from './EditSelfForm';

export const ProfileSlideOver: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ open, setOpen }) => {
  return (
    <SlideOver open={open} setOpen={setOpen} title={<ProfileAdminTitle />}>
      <EditSelfForm setOpen={setOpen} />
    </SlideOver>
  );
};

const ProfileAdminTitle = () => {
  const { data = { fullName: '', email: '' } } = useGetSelfAdminUserQuery();
  return <AdminTitle fullName={data.fullName} email={data.email} />;
};
